// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3r_Ik","icon":"SortAdornment_icon__2ACgf","up":"SortAdornment_up__1IFux","down":"SortAdornment_down__2B1IK","active":"SortAdornment_active__bPBdD"};